export const tools = {
    58: { name: "模拟驾驶" },
    59: { name: "路径搜索" },
    60: { name: "深度学习" },
    10: { name: "倒计时" },
    65: { name: "挑人" },
    7: { name: "思维网格" },
    1: { name: "电子白板" },
    52: { name: "文档" },
    3: { name: "思维导图" },
    48: { name: "表格" },
    49: { name: "学生分组" },
    4: { name: "问卷调查" },
    45: { name: "选择题" },
    15: { name: "问答" },
    16: { name: "作业提交" },
    50: { name: "批量上传" },
    41: { name: "选择匹配" },
    47: { name: "排序" },
    40: { name: "个人评价" },
    18: { name: "训练平台" },
    21: { name: "AIoT Blockly" },
    23: { name: "AI Python" },
    24: { name: "AI Blockly" },
    32: { name: "源码编辑" },
    57: { name: "CocoPi" },
    63: { name: "海龟编程" },
    28: { name: "翻译" },
    31: { name: "数字画板" },
    39: { name: "GeoGebra" },
    66: { name: "公式编辑" },
    67: { name: "分子结构" },
    68: { name: "时间轴" },
    69: { name: "英语写作" },
    70: { name: "英语口语" },
    25: { name: "目标管理" },
    26: { name: "课程设计" },
    62: { name: "交互视频" },
    51: { name: "资源库" },
    54: { name: "拍照" },
    71: { name: "AI智能体" },
    56: { name: "投票" }
};


// WEBPACK FOOTER //
// ./src/common/tools.js